const CMD_TYPE = {
  MODEL: "MODEL",
  AUDIO: "AUDIO",
  EFFECT: "EFFECT",
};

export default CMD_TYPE;
